/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
// import 'antd/dist/antd.css';
// import './index.css';
import { Table } from 'antd';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import style from './index.less';
import { guuid } from '@/utils/utils';

const SortableTable = (props) => {
  const { dataSource, groupKey, columns, callback } = props;
  const SortableItem = SortableElement((props) => <tr {...props} />);
  const SortableBody = SortableContainer((props) => <tbody {...props} />);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    // const { dataSource } = this.state;
    if (oldIndex !== newIndex) {
      // const newData = arrayMoveImmutable([].concat(dataSource), oldIndex, newIndex).filter(
      //   el => !!el,
      // );
      // console.log('Sorted items: ', newData)
      // this.setState({ dataSource: newData });
      // debugger
      callback(oldIndex, newIndex, groupKey);
    }
  };

  const DraggableContainer = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass={style.dragging}
      onSortEnd={onSortEnd}
      {...props}
    />
  );

  const DraggableBodyRow = ({ className, style, ...restProps }) => {
    // const { dataSource } = this.state;
    // function findIndex base on Table rowKey props and should always be a right array index
    let index = 0;
    if (dataSource?.length > 0) {
      index = dataSource.findIndex(
        (x) => x.index === restProps['data-row-key'],
      );
    }

    return <SortableItem index={index} {...restProps} />;
  };

  return (
    <Table
      pagination={false}
      dataSource={dataSource}
      key={guuid()}
      columns={columns}
      rowKey="index"
      components={{
        body: {
          wrapper: DraggableContainer,
          row: DraggableBodyRow,
        },
      }}
    />
  );
};

export default SortableTable;
